import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { ChartModule } from "angular-highcharts";
import { EpackLifecycleTrackingComponent } from "../epack-lifecycle-tracking/epack-lifecycle-tracking.component";
import { BmsipqcComponent } from "./bmsipqc/bmsipqc.component";
import { IpqcDashboardTableComponent } from "./bmsipqc/ipqc-dashboard-table/ipqc-dashboard-table.component";
import { IpqcPdfReportComponent } from "./bmsipqc/ipqc-pdf-report/ipqc-pdf-report.component";
import { IPQCMetadataDialougeComponent } from "./bmsipqc/metadata-dialouge/metadata-dialouge.component";
import { EpackDashboardTableComponent } from "./epack/epack-dashboard-table/epack-dashboard-table.component";
import { EpackPdfReportComponent } from "./epack/epack-pdf-report/epack-pdf-report.component";
import { ExponentEpackComponent } from "./epack/epack.component";
import { PdiMetadataDialougeComponent } from "./pdi/metadata-dialouge/metadata-dialouge.component";
import { PdiDashboardTableComponent } from "./pdi/pdi-dashboard-table/pdi-dashboard-table.component";
import { ExponentPdiComponent } from "./pdi/pdi.component";
import { MatTabsModule } from "@angular/material/tabs";
import { PicoloEpackDashboardTableComponent } from "./epack/picolo-epack-dashboard-table/picolo-epack-dashboard-table.component";
import { PiccoloIpqcDashboardTableComponent } from "./bmsipqc/piccolo-ipqc-dashboard-table/piccolo-ipqc-dashboard-table.component";
import { PiccoloPdiDashboardTableComponent } from "./pdi/piccolo-pdi-dashboard-table/piccolo-pdi-dashboard-table.component";
import { PdiLiteComponent } from "./pdi/pdi-lite/pdi-lite.component";
import { PdiLiteDashboardTableComponent } from './pdi/pdi-lite-dashboard-table/pdi-lite-dashboard-table.component';
import { PiccoloPdiLiteDashboardTableComponent } from './pdi/piccolo-pdi-lite-dashboard-table/piccolo-pdi-lite-dashboard-table.component';
import { HvEpackDashboardTableComponent } from './epack/hv-epack-dashboard-table/hv-epack-dashboard-table.component';

@NgModule({
  declarations: [
    ExponentEpackComponent,
    ExponentPdiComponent,
    EpackPdfReportComponent,
    BmsipqcComponent,
    IpqcPdfReportComponent,
    EpackLifecycleTrackingComponent,
    IpqcDashboardTableComponent,
    EpackDashboardTableComponent,
    PdiDashboardTableComponent,
    PdiMetadataDialougeComponent,
    IPQCMetadataDialougeComponent,
    PicoloEpackDashboardTableComponent,
    PiccoloIpqcDashboardTableComponent,
    PiccoloPdiDashboardTableComponent,
    PdiLiteComponent,
    PdiLiteDashboardTableComponent,
    PiccoloPdiLiteDashboardTableComponent,
    HvEpackDashboardTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ChartModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTableModule,
    MatIconModule,
    MatSelectModule,
    MatTabsModule,
  ],
  exports: [
    ExponentEpackComponent,
    ExponentPdiComponent,
    BmsipqcComponent,
    EpackLifecycleTrackingComponent,
    PdiLiteComponent,
  ],
})
export class ExponentModule {}
